import { API, graphqlOperation } from "aws-amplify";
import { getLocation } from "../graphql";

export const LocationFetch = async (pincode) => {
  return new Promise(async (resolve, reject) => {
    const res = await API.graphql(
      graphqlOperation(getLocation, {
        pincode,
      })
    );
    if (res.data.getLocation?.length) {
      resolve({
        District: res.data.getLocation[0].district
          .toLowerCase()
          .replace(/\b\w/g, (match) => match.toUpperCase()),
        State: res.data.getLocation[0].state,
        PinCode: res.data.getLocation[0].pincode,
        City : res.data.getLocation[0].city,
        Status: "success",
      });
    } else {
      console.log("failed");
      reject({ Status: "failed" });
    }
  });
};
